import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProductAnalysisDTO  {
    _originalTypeClassName = "zPMO.BO.ProductAnalysisDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProductAnalysisDTO.translate = translateService;
}
this.Items = [];
this.ProductId = null;
this.ProductName = null;
this.TotalItems = null;
this.TotalBudget = null;
this.ProjectBudget = null;
this.Description = null;
this.ProductAnalysisDTOKey = null;
this._key = this.ProductAnalysisDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
ProductId:any;
ProductName:any;
TotalItems:any;
TotalBudget:any;
ProjectBudget:any;
Description:any;
Items:any;
private _ProductAnalysisDTOKey:any;
get ProductAnalysisDTOKey(): any {
    return this._ProductAnalysisDTOKey;
  }
set ProductAnalysisDTOKey(value: any) {
    this._ProductAnalysisDTOKey = value;
    this._key = value;
  }
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.ProductAnalysisDTO.removeItems($this, $this.Items[0]);
                }

                Domain.ProductAnalysisDTO.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProductAnalysisDTO.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProductAnalysisDTO.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }

static GetPeriod($this: any, project: any): any{let p = CLMS.Framework.DateTime.ToString(project?.DateStarted, "dd/MM/yyyy") + " - ";
if (project?.DateEnded != null && CLMS.Framework.Number.GreaterThan(() => moment(project.DateEnded).year(), () => 0)) {p = p + CLMS.Framework.DateTime.ToString(project?.DateEnded, "dd/MM/yyyy");}
return p;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ProductAnalysisDTOKey == null || $this.ProductAnalysisDTOKey == 0;
            }


}